import { ApiError } from "src/types/ApiError";

export function errorHandling(err: any): string {
    const apiError = err as ApiError;
    const errorMessage = apiError?.items?.[0]?.value ?? apiError?.message ?? "Ocorreu um erro inesperado. Por favor tente novamente"
    return errorMessage;
}